import {inject, injectable} from 'inversify'

import {ISettingsStore} from '@/pages/Settings'
import {SettingsColumnItem} from '@/stores/settings'
import {RouterStore, RouterStoreSymbol} from '@/router/RouterStore'
import {getSettingsColumns} from '@/constants/settings-columns'
import {
    DossierMerchantInfoStore,
    DossierMerchantInfoStoreSymbol
} from '@/stores/profile/DossierMerchantInfo'

@injectable()
export class SettingsStore implements ISettingsStore {
    routerStore: RouterStore
    dossierMerchantStore: DossierMerchantInfoStore

    constructor(
        @inject(RouterStoreSymbol) routerStore: RouterStore,
        @inject(DossierMerchantInfoStoreSymbol) dossierMerchantStore: DossierMerchantInfoStore
    ) {
        this.routerStore = routerStore
        this.dossierMerchantStore = dossierMerchantStore
    }

    getColumns = (): SettingsColumnItem[] => {
        return getSettingsColumns({
            onCardClick: this.onCardClick,
            dossierMerchantStore: this.dossierMerchantStore
        })
    }

    onCardClick = (route: string) => {
        this.routerStore.push(route)
    }
}
